<div class="processing-view">
  <div class="processing-view-top-content-container">
    <ng-content select="[top-content]"></ng-content>
  </div>
  <div class="animation-container">
    <div class="box box-1"></div>
    <div class="box box-2"></div>
    <div class="box box-3"></div>
    <div class="box box-4"></div>
    <div class="box box-5"></div>
    <div class="box box-6"></div>
    <div class="box box-7"></div>
    <div class="box box-8"></div>
    <div class="box box-9"></div>
  </div>
  <div class="processing-view-top-content-container">
    <ng-content select="[bottom-content]"></ng-content>
  </div>
</div>
